import { render } from "./EditUserDialog.vue?vue&type=template&id=b9ba61da&scoped=true"
import script from "./EditUserDialog.vue?vue&type=script&lang=js"
export * from "./EditUserDialog.vue?vue&type=script&lang=js"

import "./EditUserDialog.vue?vue&type=style&index=0&id=b9ba61da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ba61da"]])

export default __exports__